export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      label: '客户建议',
      prop: 'group',
      column: [
        {
          label: '主键',
          prop: 'id',
          display: false,
          disabled: true,
        },
        {
          label: '小区',
          prop: 'communityId',
          type: 'tree',
          dataType: 'string',
          dicUrl: '/api/base/property/getCommunityTree',
          props: { label: 'title', value: 'id' },
          disabled: true,
        },
        {
          label: '小区名称',
          prop: 'communityName',
          disabled: true,
        },
        {
          label: '标题',
          prop: 'title',
          disabled: true,
        },
        {
          label: '阅读状态',
          prop: 'readStatus',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=read_status',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '处理标识',
          prop: 'disposeFlag',
          search: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=dispose_flag',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '内容',
          prop: 'content',
          type: 'textarea',
          overHidden: true,
          span: 24,
          row: 4,
          disabled: true,
        },
        {
          label: '附带图片',
          prop: 'imageUrl',
          type: 'upload',
          span: 24,
          propsHttp: {
            res: 'data',
            url: 'link',
            name: 'originalName',
          },
          tip: '只能上传不超过40M的文件或图片',
          action: '/api/blade-resource/oss/endpoint/put-file',
          dataType: 'string',
          disabled: true,
        },
        {
          label: '姓名',
          prop: 'name',
          disabled: true,
        },
        {
          label: '手机号',
          prop: 'phone',
          disabled: true,
        },
        {
          label: '住址',
          prop: 'site',
          disabled: true,
        },
      ],
    },
    {
      label: '客服回复',
      prop: 'group1',
      column: [
        {
          label: '回复内容',
          prop: 'response',
          type: 'textarea',
          overHidden: true,
          maxlength: 2000,
          showWordLimit: true,
          span: 24,
          row: 4,
        },
      ],
    },
  ],
};
